import SVGEditor from "@/components/dashboard/general/SVGEditor";
import { useEffect, useState } from "react";

interface ForgeShieldPageProps {
    rawSvgContent: string;
    playground?: boolean;
}

export default function ForgeShieldPage({
    rawSvgContent,
    playground,
}: ForgeShieldPageProps) {
    const [svgContent, setSvgContent] = useState<string | null>(null);

    // Set the SVG content directly from the imported string
    useEffect(() => {
        setSvgContent(rawSvgContent);
    }, [rawSvgContent]);

    if (!svgContent) {
        return <div>Loading...</div>; // Display a loading state
    }

    return (
        <div className="flex h-full flex-col items-center justify-center">
            <SVGEditor svgContent={svgContent} playground={playground} />
        </div>
    );
}
